import { useQuery } from "@tanstack/react-query";

export interface MyTierResponse {
  workspaceId: string | null;
  role: string | null;
  tier: string | null;
  displayName: string | null;
  neverbounceManualEnabled?: boolean;
}

export function useMyTier() {
  return useQuery<MyTierResponse>({
    queryKey: ["/api/me/tier"],
    staleTime: 5 * 60 * 1000,
  });
}
